import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useRoute } from 'react-router5';

import { mainSelector } from '$store/main';
import { Button } from '$uikit';
import { useTranslator } from '$hooks';
import { authSelector } from '$store/auth';
import { AuthRequired } from '$core/AuthRequired/AuthRequired';
import { RESOLVE } from '$shared/constants/pages';
import { PaymentFailed } from '$shared/components';
import { statReachGoal } from '$utils';

export const PayTipsFailed: FC = () => {
  const { hasSubscription } = useSelector(mainSelector);
  const { isLogged } = useSelector(authSelector);
  const t = useTranslator();

  const {
    route: { params },
  } = useRoute();
  const toId = +params.toId;

  useEffect(() => {
    statReachGoal('payment_failed');
    statReachGoal('send_tips_failed');
  }, []);

  if (!isLogged) {
    return <AuthRequired />;
  }

  function renderContent() {
    if (hasSubscription) {
      return (
        <PaymentFailed>
          <Link routeName={RESOLVE} routeParams={{ domain: 'id' + toId }}>
            <Button size="small">{t('pay_tips_failed_go_to_profile')}</Button>
          </Link>
        </PaymentFailed>
      );
    }
  }

  return <>{renderContent()}</>;
};
